import React, { Component } from 'react'
import mapboxgl from 'mapbox-gl'
import axios from 'axios'
import moment from 'moment';
import 'mapbox-gl/dist/mapbox-gl.css'
import styled from 'styled-components'
import { getTheme } from '../../global/utils'

import iconTrainUpdate from '../../img/icon-train-update.svg'
// import iconActive from '../../img/mapbox-icon.svg'
import iconStatic from '../../img/mapbox-icon-static.svg'
import Pusher from "pusher-js";
// import iconInactive from '../../img/mapbox-icon-inactive.svg'

mapboxgl.accessToken =
  'pk.eyJ1IjoiamdpbC1jYWZwb3dlciIsImEiOiJjbGdpa3RjN3owd3I2M21waGg0eGRzYWh0In0.OiraqZd4WlcbENK-3gSLsw';

let pusher = null;

const MapWrapper = styled.div`
    position: relative;
    .mapboxgl-map {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }

    .mapboxgl-canvas {
        outline: 0;
    }


  .mapboxgl-popup {
    max-width: 250px;
    &-tip {
      border-top-color: ${getTheme('black', '_100')} !important;
    }
    &-content {
      background-color: ${getTheme('black', '_100')};
      border-radius: ${getTheme('radius', 'm')};
      font-size: ${getTheme('fontSize', 'note')};
      font-family: 'Open Sans', 'sans-serif';
      color: ${getTheme('textColor', 'baseLight')};
      padding: ${getTheme('padding', 'verticalM')}
        ${getTheme('padding', 'horizontalM')};
    }
  }

  .train-number {
    font-weight: 800;
  }
   .train-update {
    font-weight: 600;
    text-transform: uppercase;
  }
  .train-update-label {
    text-transform: uppercase;
    color: ${getTheme('textColor', 'altLight')};
  }

  .mapboxgl-ctrl-attrib,
  .mapboxgl-ctrl-logo {
    display: none;
  }
`

class Map extends Component {

    constructor() {
        super();

        // lng: -1.98491,
        // lat: 43.29305,
        this.state = {
            mapLng: 80,
            mapLat: 18,
            timestamp: 0,
            mapZoom: 4,
            map: null,
            //marker_ut0: null,
            mapGeoJsonData: null,
            markers: [],
            popup: null,
        }
    }

    initMarker(p_trainUnit, p_lng, p_lat, p_timestamp_ago) {
        let marker  = {
            type: 'Feature',
            geometry: {
                type: 'Point',
                coordinates: [p_lng, p_lat]
            },
            properties: {
                number: p_trainUnit,
                name: '',
                update: p_timestamp_ago,
                icon: {
                    iconUrl: iconStatic,
                    iconSize: [22, 22]
                }
            }
        };
        return marker;
    }

    startMap() {
        const map = new mapboxgl.Map({
            container: this.mapContainer,
            style: 'mapbox://styles/mapbox/light-v9',
            center: [this.state.mapLng, this.state.mapLat],
            zoom: this.state.mapZoom
        })

        this.setState({ map: map });

        /*--------------------------------------------------------------------------------*/

        const markerUT_30539 = this.initMarker('30539', 0, 0, '?');
        const markerUT_32482 = this.initMarker('32482', 0, 0, '?');
        const markerUT_37133 = this.initMarker('37133', 0, 0, '?');
        const markerUT_33592 = this.initMarker('33592', 0, 0, '?');
        const markerUT_9999 = this.initMarker('9999', 0, 0, '?');

        const geoJsonArray = [
            markerUT_30539,
            markerUT_32482,
            markerUT_37133,
            markerUT_33592,
            markerUT_9999
        ];

        const geoJsonData = {
            type: 'FeatureCollection',
            features: geoJsonArray
        }
        this.setState({mapGeoJsonData: geoJsonData});

        map.on('load', () => {
            map.addSource('markers', {
                type: 'geojson',
                data: geoJsonData
            });
            map.addLayer({
                id: 'markers',
                interactive: true,
                source: 'markers',
                type: 'circle',
                paint: {
                    'circle-radius': 20,
                    'circle-color': 'transparent'
                }
            })

            var popup = new mapboxgl.Popup({
                offset: 25,
                closeButton: false,
                closeOnClick: false
            })

            map.on('mouseenter', 'markers', function(e) {
                var coordinates = e.features[0].geometry.coordinates.slice();
                if (coordinates[0] === 0 && coordinates[1] === 0) {
                    return true;
                }
                map.getCanvas().style.cursor = 'pointer';
                var trainNumber = e.features[0].properties.number;
                var trainName = e.features[0].properties.name;
                var trainUpdate = e.features[0].properties.update;
                var description =
                    '<div><span class="train-number">' +
                    trainNumber + '  ' +
                    '</span> ' +
                    trainName +
                    '</div><div><span class="train-update-label"><img src="' +
                    iconTrainUpdate +
                    '"alt="" /> Last updated:</span> <span class="train-update">' +
                    trainUpdate +
                    '</span></div>'

                // Ensure that if the map is zoomed out such that multiple
                // copies of the feature are visible, the popup appears
                // over the copy being pointed to.
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360
                }

                // Populate the popup and set its coordinates
                // based on the feature found.
                popup
                    .setLngLat(coordinates)
                    .setHTML(description)
                    .addTo(map)

            });

            map.on('mouseleave', 'markers', function(e) {
                map.getCanvas().style.cursor = '';
                popup.remove();
            })

            let markers = [];
            this.state.mapGeoJsonData.features.forEach(feature => {
                let marker = document.createElement('div')
                marker.style.backgroundImage =
                    'url(' + feature.properties.icon.iconUrl + ')'
                marker.style.backgroundSize = 'cover'
                marker.style.width = '40px'
                marker.style.height = '40px'

                // add marker to map
                let map_marker = new mapboxgl.Marker(marker)
                    .setLngLat(feature.geometry.coordinates)
                    .addTo(map);

                let number = feature.properties.number;
                if (feature.geometry.coordinates[0] === 0 && feature.geometry.coordinates[1] === 0) {
                    map_marker._element.style.visibility = 'hidden';
                }
                let item = {'number': number, 'map_marker': map_marker};
                markers.push(item);
            });
            this.setState({ markers: markers, popup: popup });
            this.startWebsockets();
            this.startDataTransmission();
        });

        /*--------------------------------------------------------------------------------*/

        let el = document.createElement('div');
        el.className = 'marker';

        // add marker to map
        //let marker = new mapboxgl.Marker()
        //    .setLngLat({ lng, lat })
        //    .addTo(map);
        //this.setState({ marker_ut0: marker });

        map.on('move', () => {
            const { lng, lat } = map.getCenter()
            this.setState({
                mapLng: lng.toFixed(4),
                mapLat: lat.toFixed(4),
                mapZoom: map.getZoom().toFixed(2)
            });
        })
    }

    updateMarkerUt(p_trainUnit, p_lng, p_lat) {
        let lng = parseFloat(p_lng)
        let lat = parseFloat(p_lat)

        this.state.markers.forEach(marker => {
            if (marker.number === p_trainUnit) {
                marker.map_marker.setLngLat({lng, lat});
                if (p_lng !== 0 || p_lat !== 0) {
                    marker.map_marker._element.style.visibility = 'visible';
                }
            }
        });
        this.state.popup.remove();
        // this.state.map.easeTo({center: [lng, lat], speed: 1.0, zoom:16});
    }

    showMarker() {
        if (this.state.map.getSource('markers')) {
            let m = this.state.markers;
            m[0].map_marker._element.style.visibility = 'visible';
            this.setState({ markers: m });
        }
    }

    updateMarkers(p_trainUnit, p_lng, p_lat, p_timestamp) {
        let timestamp_ago = moment(p_timestamp).fromNow();

        this.state.mapGeoJsonData.features.forEach(feature => {
            if (feature.properties.number === p_trainUnit) {
                feature.geometry.coordinates = [p_lng, p_lat];
                feature.properties.update = timestamp_ago;
            }
        });

        if (this.state.map.getSource('markers')) {
            this.state.map.getSource('markers').setData(this.state.mapGeoJsonData);
            this.updateMarkerUt(p_trainUnit, p_lng, p_lat);

        } else {
            console.log('??????? without getSource ??????')
        }
    }

    receiveRoomData(p_trainUnit, p_data) {
        console.log('------------------------------------');
        console.log('- ## from pusher: ' + new Date().toLocaleTimeString());
        let train_unit = p_data['train_unit'];
        let latitude = p_data['latitude'];
        let longitude = p_data['longitude'];
        let timestamp = p_data['timestamp'];
        console.log('ut:'+train_unit+' lat:'+latitude+' lng:'+longitude+' tms:'+timestamp);


        if (latitude === this.state.mapLat && longitude === this.state.mapLng) {
            // same position.
        } else {
            this.setState({
                mapLng: longitude,
                mapLat: latitude,
                timestamp: timestamp
            });
            this.updateMarkers(p_trainUnit, longitude, latitude, timestamp);
        }
    }

    startWebsockets() {
        pusher = new Pusher(process.env.REACT_APP_PUSHER_APP_KEY, {
            cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
            forceTLS: true
        });

        let channel = pusher.subscribe('gps-channel');
        channel.bind('room_'+process.env.REACT_APP_CLW_ROOM_UT_NAME_30539, function(data) {
            this.receiveRoomData(process.env.REACT_APP_CLW_ROOM_UT_NAME_30539, data);
        },this);
        channel.bind('room_'+process.env.REACT_APP_CLW_ROOM_UT_NAME_32482, function(data) {
            this.receiveRoomData(process.env.REACT_APP_CLW_ROOM_UT_NAME_32482, data);
        },this);
        channel.bind('room_'+process.env.REACT_APP_CLW_ROOM_UT_NAME_37133, function(data) {
            this.receiveRoomData(process.env.REACT_APP_CLW_ROOM_UT_NAME_37133, data);
        },this);
        channel.bind('room_'+process.env.REACT_APP_CLW_ROOM_UT_NAME_33592, function(data) {
            this.receiveRoomData(process.env.REACT_APP_CLW_ROOM_UT_NAME_33592, data);
        },this);


        if (process.env.REACT_APP_DEVELOPMENT === '1') {
            channel.bind('room_' + process.env.REACT_APP_CLW_ROOM_UT_NAME_9999, function (data) {
                this.receiveRoomData(process.env.REACT_APP_CLW_ROOM_UT_NAME_9999, data);
            }, this);
        }
    }

    endWebSockets(){
        console.log("disconnect");
        pusher.disconnect();
        //this.ws.close();
    }

    /*
    startDataTransmission_old() {
        axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
        axios.defaults.xsrfCookieName = "csrftoken";
        axios.defaults.withCredentials = true;
        console.log('startDataTransmission.........');
        const url = process.env.REACT_APP_API_SERVER+'/api/v01/gps/'+process.env.REACT_APP_CLW_ROOM_UT_NAME_9999+'/';
        axios.get(url)
            .then(res => {
                if (res.data.code === 201) {
                    // console.log('---startDataTransmission(201)::: last -> lng:'+res.data.lng+', lat:'+res.data.lat, ', timestamp:'+res.data.timestamp);
                    if ((this.state.timestamp < res.data.timestamp) || (parseFloat(this.state.mapLng)===0)) {
                        // console.log('upd.');
                        this.setState({
                            mapLng: res.data.lng,
                            mapLat: res.data.lat,
                            timestamp: res.data.timestamp
                        });
                        this.updateMarkers(process.env.REACT_APP_CLW_ROOM_UT_NAME_9999, res.data.lng, res.data.lat);
                    } else {
                        console.log('not upd.');
                        console.log('--- last -> lng:'+this.state.mapLng+', lat:'+this.state.mapLat, ', timestamp:'+this.state.timestamp);
                    }
                }
                if (res.data.code === 200) {
                    this.hideMarker();
                }
            })
            .catch(err => {
                console.log('ERROR !!!!, Hiding marker.'+err.message);
                if ((parseFloat(this.state.mapLng)===0) && (parseFloat(this.state.mapLat)===0)) {
                    this.hideMarker();
                }
            })
    };
    */

    startDataTransmission(){
        this.startDataTransmissionTrainUnit(process.env.REACT_APP_CLW_ROOM_UT_NAME_30539);
        this.startDataTransmissionTrainUnit(process.env.REACT_APP_CLW_ROOM_UT_NAME_32482);
        this.startDataTransmissionTrainUnit(process.env.REACT_APP_CLW_ROOM_UT_NAME_37133);
        this.startDataTransmissionTrainUnit(process.env.REACT_APP_CLW_ROOM_UT_NAME_33592);

        if (process.env.REACT_APP_DEVELOPMENT === '1') {
            this.startDataTransmissionTrainUnit(process.env.REACT_APP_CLW_ROOM_UT_NAME_9999);
        }
    }
    startDataTransmissionTrainUnit(p_trainUnit) {
        axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
        axios.defaults.xsrfCookieName = "csrftoken";
        axios.defaults.withCredentials = true;
        console.log('startDataTransmission.........');
        const url = process.env.REACT_APP_API_SERVER+'/api/v01/gps/'+p_trainUnit+'/';
        axios.get(url)
            .then(res => {
                if (res.data.code === 201) {
                    console.log(res.data);
                    this.updateMarkers(p_trainUnit, res.data.lng, res.data.lat, res.data.timestamp);
                }
            })
            .catch(err => {
                console.log('ERROR !!!! '+err.message);
            })
    };

    componentDidMount() {
        this.startMap();
    }

    componentWillUnmount() {
        this.endWebSockets();
    }


  render() {
    // const { lng, lat, zoom } = this.state

    return (
      <MapWrapper className={this.props.className}>
        <div ref={el => (this.mapContainer = el)} />
      </MapWrapper>
    )
  }
}

export default Map



// WEBPACK FOOTER //
// ./src/components/map/Map.js